import Multiselect from './Multiselect.wrapper';

export default Multiselect;
export { Multiselect };
